<script lang="ts" setup>
  import { ref } from 'vue';
  import { api } from '../../../../shared/api/client.ts';
  import type { LobbyView } from '../../../../shared/api/lobby.ts';
  import { meetsStaleView, messageOf } from '../../../../shared/api/serverFailure.ts';
  import LobbyHostView from './LobbyHostView.vue';

  defineProps<{ data: LobbyView; showRules: boolean }>();
  const emit = defineEmits<{ settingsUpdated: [] }>();

  const startGame = async () => {
    const { error } = await api.POST('/game/start');

    if (error && !meetsStaleView(error.slug)) {
      err.value = messageOf('startGame', error);
      return;
    }
  };

  const err = ref<string>('');
</script>

<template>
  <LobbyHostView
    :data="data"
    :error="err"
    :show-rules="showRules"
    @settings-updated="emit('settingsUpdated')"
    @start-game="startGame"
  />
</template>
